import { Typography } from "@tm/components"

export type AddressLineValue = { label: string; value?: string | number }

export default function AddressLine(props: AddressLineValue) {
    return (
        <>
            <Typography fontWeight="bold" fontSize="1rem" style={{ flex: "0 1 25em" }}>
                {props.label}
            </Typography>
            <Typography fontSize="1rem">{props.value}</Typography>
        </>
    )
}
